import { app } from '../../../app';
import { Controller } from './statistics.controller';

app.component('userStatistics', {
    bindings: {
        account: '<',
        logs: '<',
    },
    controller: Controller,
    templateUrl: require('./statistics.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/statistics/statistics.component.js